import { render, staticRenderFns } from "./email-stats.vue?vue&type=template&id=b4d24c2c&scoped=true&"
import script from "./email-stats.vue?vue&type=script&lang=js&"
export * from "./email-stats.vue?vue&type=script&lang=js&"
import style0 from "./email-stats.vue?vue&type=style&index=0&id=b4d24c2c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4d24c2c",
  null
  
)

export default component.exports